import { selectors } from 'modules/common';
import { useCompanyBasedOnUrl } from 'shared/hooks';

export const useIsManualMatchingVisible = () => {
    const company = useCompanyBasedOnUrl();

    const isManualMatchingEnabled = company.billMatchingSettings?.manualMatchingEnabled || false;
    const isQBooksMatchingAvailable = selectors.company.getQBOMatchingIsAvailable(company);

    return isManualMatchingEnabled && isQBooksMatchingAvailable;
};
